import React, {useContext} from "react";
import SectionHeading from "../SectionHeading";
import './Experience.css';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Padding } from "@mui/icons-material";
import {PortfolioContext} from '../../App';


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};


function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
}
  

const useIsMobile = () => {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  
    React.useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return isMobile;
};

const Experience = () => {
    const portfolio = useContext(PortfolioContext);
    const experiences = portfolio['experiences'] || "";
    console.log(experiences);

    const isMobile = useIsMobile();
    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    return (
        <section className="experience-section" id="experience">
            <SectionHeading number={'02.'} heading={'Where I’ve Worked'} />
            <div>
                <Box
                    sx={{ 
                        flexGrow: 1, bgcolor: 'transparent', display: 'flex', height: '500px', marginTop: '30px',
                        '@media (max-width: 768px)': {
                            flexDirection: 'column', 
                        },
                    }}
                >
                <Tabs
                    orientation={isMobile ? 'horizontal' : 'vertical'}
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs example"
                    sx={{ 
                        display: 'flex',
                        alignItems: 'flex-start', // Align tabs to the top
                        height: 'auto',
                    }}
                    TabIndicatorProps={{
                        style: {
                          left: 0,       // Set the indicator to be aligned to the left
                          width: '4px',  // Adjust the width of the indicator as needed
                          backgroundColor: '#37DBB2',
                        },
                    }}
                >
                {experiences && experiences.map((company, i) => (
                        <Tab 
                            key={i}
                            label={company.name} {...a11yProps(i)} 
                            sx={{ 
                                '.MuiTab-textColorPrimary': '#8892b0',
                                '.MuiTab-textColorSecondary': '#37DBB2',
                                borderLeft: 4, 
                                borderColor: '#112240', 

                                color: '#8892b0',
                                fontFamily: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
                                textAlign: 'left',
                                fontSize: '12px',
                                '&.Mui-selected': {
                                    color: '#37DBB2', 
                                    backgroundColor: '#112240',
                                },
                                '@media (max-width: 768px)': {
                                    borderBottom: 4,    // Smaller border for mobile view
                                    borderLeft: 0,
                                },
                            }}  

                        />
                ))}
                
                </Tabs>
                {experiences && experiences.map((company, i) => (
                    <TabPanel value={value} index={i}  key={i}
                        sx={{
                            padding: '0px',
                            margin: '0px',
                        }}
                        className='styled-tabpanel'
                    >
                            <h3>
                                <span>{company.designation}</span>
                                <span className="company">
                                    &nbsp;@
                                    <a href='#' className="inline-link"> {company.name} </a>
                                </span>
                            </h3>
                            <p className="range">{company.dates} </p>
                            <ul className="work-list">
                                {company.learnings && company.learnings.map((learning, i) => <li key={i}>{learning}</li>)}
                            </ul>
                    </TabPanel>
                ))}
               
            </Box>

            </div>


        </section>

    )
}

export default Experience;